import "./ClientInjuryDetailsScreen.scss";
import {Field, FieldArray, FieldProps, Form, Formik, FormikHelpers} from 'formik';
import {ImageConfig, Misc} from "../../../constants";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import * as Yup from "yup";
import {IClientInjuryDetails} from "../../../shared/models/client.model";
import React, {useCallback, useEffect, useState} from "react";
import _ from "lodash";
import FormikDatePickerComponent
    from "../../../shared/components/form-controls/formik-date-picker/FormikDatePickerComponent";
import {useDispatch, useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import IconButtonComponent from "../../../shared/components/icon-button/IconButtonComponent";
import FormikSelectDropdownComponent
    from "../../../shared/components/form-controls/formik-select-dropdown/FormikSelectDropdownComponent";
import FormikTextAreaComponent from "../../../shared/components/form-controls/formik-text-area/FormikTextAreaComponent";
import FormikRadioButtonGroupComponent
    from "../../../shared/components/form-controls/formik-radio-button-group/FormikRadioButtonGroupComponent";
import {CommonService} from "../../../shared/services";
import FormikInputComponent from "../../../shared/components/form-controls/formik-input/FormikInputComponent";
import FormikPhoneInputComponent from "../../../shared/components/formik-phone-input/FormikPhoneInputComponent";
import {IAPIResponseType} from "../../../shared/models/api.model";
import {setClientInjuryDetails} from "../../../store/actions/client.action";
import LevelOfPainComponent from "../../../shared/components/level-of-pain/LevelOfPainComponent";
import moment from "moment";

const BODY_PART = {
    body_part_id: "",
    body_part_details: "",
    body_side: "",
};

const BodyPartsValidationSchema = Yup.object().shape({
    body_part_id: Yup.mixed().required("Required"),
    body_part_details: Yup.mixed().nullable(),
    body_side: Yup.mixed().required("Required"),

});

const ClientInjuryDetailsFormInitialValues: any = {
    "onset_date": "",
    "surgery_date": "",
    "injury_body_parts": [
        BODY_PART
    ],
    "injury_occurrence_details": "",
    "pain_level": "",
    "injury_aggravation_details": "",
    "injury_healing_details": "",
    "prev_injury_occurrence": {
        "is_injury_occurred_before": undefined,
        "prev_injury_details": ''
    },
    "is_treated": undefined,
    "diagnostic_details": {
        "is_diagnosed": undefined,
        "name": "",
        "phone": "",
        "next_appointment": "",
        "diagnosis": ""
    },
    "is_injury_form_filled": undefined
}

const ClientInjuryDetailsFormValidationSchema = Yup.object({
    onset_date: Yup.mixed().required('Required'),
    // surgery_date: Yup.mixed().required('Required'),
    injury_body_parts: Yup.array().of(BodyPartsValidationSchema),
    injury_occurrence_details: Yup.mixed().required('Required'),
    pain_level: Yup.number().required('Required'),
    injury_aggravation_details: Yup.mixed().required('Required'),
    injury_healing_details: Yup.mixed().required('Required'),
    is_treated: Yup.mixed().required('Required'),
    prev_injury_occurrence: Yup.object({
        is_injury_occurred_before: Yup.mixed().required('Required'),
        prev_injury_details: Yup.mixed().nullable().when("is_injury_occurred_before", {
            is: (is_injury_occurred_before: boolean) => is_injury_occurred_before,
            then: Yup.mixed().required('Required'),
            otherwise: Yup.mixed().nullable()
        }),
    }),
    diagnostic_details: Yup.object().when("is_treated", {
        is: (is_treated: boolean) => is_treated,
        then: Yup.object({
            is_diagnosed: Yup.mixed().required('Required'),
            name: Yup.mixed().required('Required'),
            phone: Yup.mixed().required('Required'),
            // next_appointment: Yup.mixed().required('Required'),
            diagnosis: Yup.mixed().nullable().when("is_diagnosed", {
                is: (is_diagnosed: boolean) => is_diagnosed,
                then: Yup.mixed().required('Required'),
                otherwise: Yup.mixed().nullable()
            }),
        })
    })
});

interface ClientInjuryDetailsScreenProps {
    onNext?: () => void;
    formId?: string;
    initialValues?: any;
    mode?: string;
    appointmentId: any;
    onSubmitComplete?: (values: any) => void;
}

const ClientInjuryDetailsScreen = (props: ClientInjuryDetailsScreenProps) => {
    const {onNext, onSubmitComplete, mode, appointmentId, formId, initialValues} = props;
    const {bodyPartList} = useSelector((state: IRootReducerState) => state.staticData);
    const [clientInjuryDetailsFormInitialValues, setClientInjuryDetailsFormInitialValues] = useState<IClientInjuryDetails>(_.cloneDeep(ClientInjuryDetailsFormInitialValues));
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const {clientInjuryDetails} = useSelector((state: IRootReducerState) => state.client);
    const dispatch = useDispatch();

    const onSubmit = useCallback((values: any, {setSubmitting, setErrors}: FormikHelpers<any>) => {
        setSubmitting(true);
        const payload = CommonService.removeKeysFromJSON(_.cloneDeep(values), ['body_part_details']);
        payload.appointment_id = appointmentId ? appointmentId : currentUser?.appointment_id;
        payload.onset_date = payload.onset_date && CommonService.convertDateFormat(payload.onset_date);
        payload.surgery_date = payload.surgery_date && CommonService.convertDateFormat(payload.surgery_date);
        payload.diagnostic_details.next_appointment = payload?.diagnostic_details?.next_appointment && CommonService.convertDateFormat(payload?.diagnostic_details?.next_appointment);
        payload.is_onboard_injury_form_filled = true;
        payload.is_injury_form_filled = true;
        if (!formId) {
            CommonService._client.ClientInjuryDetailsSaveAPICall(payload)
                .then((response: IAPIResponseType<IClientInjuryDetails>) => {
                    CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY] || 'Injured details has been saved', "success");
                    setSubmitting(false);
                    onNext && onNext();
                    dispatch(setClientInjuryDetails(response?.data));
                    // navigate(CommonService._routeConfig.ClientInjurySuccess('injury-form'));
                })
                .catch((error: any) => {
                    CommonService.handleErrors(setErrors, error);
                    setSubmitting(false);
                });
        } else {
            CommonService._client.ClientInjuryDetailsUpdateAPICall(payload, formId)
                .then((response: IAPIResponseType<IClientInjuryDetails>) => {
                    CommonService._alert.showToast(response[Misc.API_RESPONSE_MESSAGE_KEY] || 'Injured details has been saved', "success");
                    setSubmitting(false);
                    onSubmitComplete && onSubmitComplete(values);
                    // navigate(CommonService._routeConfig.ClientInjurySuccess('injury-form'));
                })
                .catch((error: any) => {
                    CommonService.handleErrors(setErrors, error);
                    setSubmitting(false);
                });
        }
    }, [onNext, formId, appointmentId, currentUser, onSubmitComplete, dispatch]);

    useEffect(() => {
        if (initialValues) {
            setClientInjuryDetailsFormInitialValues(initialValues);
        } else if (clientInjuryDetails && clientInjuryDetails !== {} && clientInjuryDetails?.length !== 0 && mode !== 'add' && !formId) {
            setClientInjuryDetailsFormInitialValues(clientInjuryDetails);
        }
    }, [mode, initialValues, clientInjuryDetails, formId])

    return (
        <div className={'client-registration-details-block client-injury-details-screen'}>
            <div className="client-registration-details-block__header">
                <div className="client-registration-details-block__title injury-heading">
                    New Injury/Condition Information
                </div>
            </div>
            <div className={'client-registration-form-description mrg-bottom-25'}>
                Please provide as much detail below regarding your current injury/condition.
            </div>
            <Formik
                validationSchema={ClientInjuryDetailsFormValidationSchema}
                initialValues={clientInjuryDetailsFormInitialValues}
                validateOnChange={false}
                validateOnBlur={true}
                enableReinitialize={true}
                validateOnMount={true}
                onSubmit={onSubmit}
            >
                {({values, setFieldValue, isSubmitting, resetForm, isValid, validateForm, errors}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                    }, [validateForm, values]);
                    return (
                        <Form className={"t-form"} noValidate={true}>
                            {/*<FormDebuggerComponent values={values} errors={errors} showDebugger={true}/>*/}
                            <div
                                className={"client-injury-details-form-body t-form-controls client-injury-details-form-controls with-icons"}>
                                <div className="ts-row">
                                    <div className="ts-col pdd-left-15">
                                        <Field name={'onset_date'} className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <FormikDatePickerComponent
                                                        label={'Date of Onset'}
                                                        placeholder={'Select Date'}
                                                        formikField={field}
                                                        required={true}
                                                        fullWidth={true}
                                                        maxDate={moment()}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className="ts-col">
                                        <Field name={'surgery_date'} className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <FormikDatePickerComponent
                                                        label={'Surgery Date'}
                                                        formikField={field}
                                                        placeholder={'Select Date'}
                                                        required={false}
                                                        fullWidth={true}
                                                        // maxDate={new Date()}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className="ts-col-md-1"/>
                                </div>
                                <FieldArray
                                    name="injury_body_parts"
                                    render={arrayHelpers => (
                                        <>
                                            {values?.injury_body_parts && values?.injury_body_parts?.map((item: any, index: any) => {
                                                return (
                                                    <div className="ts-row" key={index + item?._id}>
                                                        <div className="ts-col pdd-left-15">
                                                            <Field
                                                                name={`injury_body_parts[${index}].body_part_id`}>
                                                                {
                                                                    (field: FieldProps) => (
                                                                        <FormikSelectDropdownComponent
                                                                            options={bodyPartList}
                                                                            label={'Body Part'}
                                                                            displayWith={(item: any) => item?.name}
                                                                            valueExtractor={(item: any) => item?._id}
                                                                            formikField={field}
                                                                            required={true}
                                                                            fullWidth={true}
                                                                            onUpdate={(value) => {
                                                                                setFieldValue(`injury_body_parts[${index}].body_side`, '');
                                                                            }}
                                                                        />
                                                                    )
                                                                }
                                                            </Field>
                                                        </div>
                                                        <div className="ts-col">
                                                            <Field
                                                                name={`injury_body_parts[${index}].body_side`}>
                                                                {
                                                                    (field: FieldProps) => (
                                                                        <FormikSelectDropdownComponent
                                                                            disabled={!values?.injury_body_parts[index]?.body_part_id || !(bodyPartList.find((item: any) => item?._id === values?.injury_body_parts[index]?.body_part_id) || !bodyPartList.find((item: any) => item?._id === values?.injury_body_parts[index]?.body_part_id)?.medical_record_applicable_sides || bodyPartList.find((item: any) => item?._id === values?.injury_body_parts[index]?.body_part_id)?.medical_record_applicable_sides?.length === 0)}
                                                                            options={bodyPartList.find((item: any) => item?._id === values?.injury_body_parts[index]?.body_part_id)?.medical_record_applicable_sides || []}
                                                                            label={'Body Side'}
                                                                            formikField={field}
                                                                            displayWith={(item: any) => item}
                                                                            valueExtractor={(item: any) => item}
                                                                            required={values?.injury_body_parts[index]?.body_part_details?.sides?.length > 0}
                                                                            fullWidth={true}
                                                                        />
                                                                    )
                                                                }
                                                            </Field>
                                                        </div>
                                                        <div
                                                            className="ts-col-sm-12 ts-col-lg-1 ts-col-md-1 d-flex ts-align-items-center">
                                                            {values?.injury_body_parts?.length > 1 &&
                                                                <IconButtonComponent
                                                                    className={'pdd-left-0 pdd-right-10'}
                                                                    onClick={() => {
                                                                        arrayHelpers.remove(index)
                                                                    }}>
                                                                    <ImageConfig.DeleteIcon/>
                                                                </IconButtonComponent>
                                                            }
                                                            {
                                                                (index === values?.injury_body_parts?.length - 1) &&
                                                                <IconButtonComponent
                                                                    onClick={() => {
                                                                        arrayHelpers.push(BODY_PART);
                                                                    }}
                                                                >
                                                                    <ImageConfig.AddCircleIcon/>
                                                                </IconButtonComponent>
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </>
                                    )}/>
                                <div className="ts-row">
                                    <div className="ts-col-sm-12 ts-col-lg pdd-left-15">
                                        <Field name={'injury_occurrence_details'} className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <FormikTextAreaComponent
                                                        label={'Please describe how your injury/condition occurred?'}
                                                        placeholder={'Enter your comments here…'}
                                                        formikField={field}
                                                        required={true}
                                                        fullWidth={true}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className="ts-col-sm-12 ts-col-lg-1"/>
                                </div>
                                <div className="ts-row">
                                    <div className="ts-col-12 pdd-left-10 pain-level-form-control">
                                        <Field name={'pain_level'} className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    // <FormikRadioButtonGroupComponent
                                                    //     label={'What is your current level of pain? (0 = No Pain; 10 = Worse imaginable pain)'}
                                                    //     formikField={field}
                                                    //     required={true}
                                                    //     options={CommonService._staticData.injurySeverityLevels}
                                                    //     displayWith={(item: any) => item}
                                                    //     keyExtractor={(item: any) => item}
                                                    //     valueExtractor={(item: any) => item}
                                                    // />
                                                    <LevelOfPainComponent formikField={field}
                                                                          label={'What is your current level of pain? (0 = No Pain; 10 = Worse imaginable pain)'}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className="ts-col-lg-1"/>
                                </div>
                                <div className="ts-row">
                                    <div className="ts-col-sm-12 ts-col-lg">
                                        <Field name={'injury_healing_details'} className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <FormikTextAreaComponent
                                                        label={'Since the onset of your injury/condition, what has made your injury/condition feel better?'}
                                                        placeholder={'Please enter your comments here'}
                                                        formikField={field}
                                                        required={true}
                                                        fullWidth={true}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className="ts-col-lg-1"/>
                                </div>
                                <div className="ts-row">
                                    <div className="ts-col-sm-12 ts-col-lg">
                                        <Field name={'injury_aggravation_details'} className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <FormikTextAreaComponent
                                                        label={'What has made your injury/condition feel worse?'}
                                                        placeholder={'Enter your comments here…'}
                                                        formikField={field}
                                                        required={true}
                                                        fullWidth={true}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className="ts-col-lg-1"/>
                                </div>
                                <div className="ts-row">
                                    <div
                                        className={`ts-col-sm-12 ts-col-lg radio-inline-options ${values.prev_injury_occurrence?.is_injury_occurred_before ? 'injury-occurred' : ''}`}>
                                        <Field name={'prev_injury_occurrence.is_injury_occurred_before'}
                                               className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <FormikRadioButtonGroupComponent
                                                        label={'Has this injury/condition or similar injury/condition occurred before?'}
                                                        formikField={field}
                                                        required={true}
                                                        options={CommonService._staticData.yesNoOptions}
                                                        onChange={() => {
                                                            setFieldValue('prev_injury_occurrence.prev_injury_details', '');
                                                        }}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className="ts-col-lg-1"/>
                                </div>
                                {
                                    values?.prev_injury_occurrence?.is_injury_occurred_before &&
                                    <div className="ts-row">
                                        <div className="prev_injury_details ts-col">
                                            <Field name={'prev_injury_occurrence.prev_injury_details'}
                                                   className="t-form-control">
                                                {
                                                    (field: FieldProps) => (
                                                        <FormikTextAreaComponent
                                                            label={'If so, please provide details below (ie. when, what happened, etc) :'}
                                                            placeholder={'Enter your comments here…'}
                                                            formikField={field}
                                                            required={true}
                                                            fullWidth={true}
                                                        />
                                                    )
                                                }
                                            </Field>
                                        </div>
                                        <div className="ts-col-lg-1"/>
                                    </div>
                                }
                                <div className="ts-row">
                                    <div className="ts-col-sm-12 ts-col-lg radio-inline-options">
                                        <Field name={'is_treated'} className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <FormikRadioButtonGroupComponent
                                                        label={'Have you seen a doctor for this injury/condition:'}
                                                        formikField={field}
                                                        required={true}
                                                        options={CommonService._staticData.yesNoOptions}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    <div className="ts-col-lg-1"/>
                                </div>
                                {
                                    values?.is_treated &&
                                    <>
                                        <div className="ts-row">
                                            <div className="ts-col-lg-1"/>
                                        </div>
                                        <div className="ts-row">
                                            <div className="ts-col-sm-12 ts-col-lg">
                                                <Field name={'diagnostic_details.name'} className="t-form-control">
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikInputComponent
                                                                label={'Name of Doctor'}
                                                                placeholder={'Enter Doctor’s Name'}
                                                                formikField={field}
                                                                required={true}
                                                                fullWidth={true}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </div>
                                            <div className="ts-col-lg-1"/>
                                        </div>
                                        <div className="ts-row">
                                            <div className="ts-col-sm-12 ts-col-md ts-col-lg">
                                                <Field name={'diagnostic_details.phone'} className="t-form-control">
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikPhoneInputComponent
                                                                label={"Doctor’s Phone Number"}
                                                                formikField={field}
                                                                required={true}
                                                                fullWidth={true}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </div>
                                            <div className="ts-col-sm-12 ts-col-md ts-col-lg">
                                                <Field name={'diagnostic_details.next_appointment'}
                                                       className="t-form-control">
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikDatePickerComponent
                                                                label={'Date of Next Doctor\'s Appointment'}
                                                                placeholder={'MM-DD-YYYY'}
                                                                formikField={field}
                                                                fullWidth={true}
                                                                minDate={moment()}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </div>
                                            <div className="ts-col-lg-1"/>
                                        </div>
                                        <div className="ts-row">

                                            <div className="ts-col-sm-12 ts-col-lg">
                                                <Field name={'diagnostic_details.diagnosis'}
                                                       className="t-form-control">
                                                    {
                                                        (field: FieldProps) => (
                                                            <FormikTextAreaComponent
                                                                label={'Medical Diagnosis'}
                                                                placeholder={'Enter your comments here'}
                                                                formikField={field}
                                                                required={true}
                                                                fullWidth={true}
                                                            />
                                                        )
                                                    }
                                                </Field>
                                            </div>
                                            <div className="ts-col-lg-1"/>
                                        </div>
                                    </>
                                }
                                <div className={'ts-row'}>
                                    <div className="ts-col-sm-12 ts-col-lg  radio-inline-options">
                                        <Field name={'diagnostic_details.is_diagnosed'}
                                               className="t-form-control">
                                            {
                                                (field: FieldProps) => (
                                                    <FormikRadioButtonGroupComponent
                                                        label={'Have you had any diagnostics for this injury/condition (MRI, XRAY, etc):'}
                                                        formikField={field}
                                                        options={CommonService._staticData.yesNoOptions}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </div>
                                    {
                                        values?.diagnostic_details?.is_diagnosed &&
                                        <div className="is-diagnised-note">
                                            Please bring any diagnostic reports of your injury/condition with you to
                                            your appointment.
                                        </div>
                                    }
                                </div>
                                <div className={'t-form-actions mrg-top-40'}>
                                    <ButtonComponent
                                        type={"submit"}
                                        size={'large'}
                                        isLoading={isSubmitting}
                                        disabled={!isValid}
                                        suffixIcon={<ImageConfig.ArrowRightCircle/>}
                                    >
                                        {!formId && mode !== 'add' ? "Next" : "Submit"}
                                    </ButtonComponent>
                                </div>
                            </div>
                        </Form>
                    )
                }
                }
            </Formik>
        </div>
    );

};

export default ClientInjuryDetailsScreen;
